import React from 'react';
import './Badge.css';

const LicensedInsured = () => {
  return (
    <div className="badge-flag warranty-badge">
      {/* Circle with checkmark */}
      <div className="badge-shield">
        {/* Outer shield (black outline) */}
        <i className="fa-solid fa-shield shield-outline" aria-hidden="true"></i>

        {/* Middle shield (white border) */}
        <i className="fa-solid fa-shield shield-border" aria-hidden="true"></i>

        {/* Inner shield (fill) */}
        <i className="fa-solid fa-shield shield-fill" aria-hidden="true"></i>

        {/* Center checkmark */}
        <i className="fa-solid fa-check shield-check" aria-hidden="true"></i>
      </div>

      {/* Flag text */}
      <div className="badge-flag-text">
        <span className="line">LICENSED &</span>
        <span className="line">INSURED</span>
      </div>
    </div>
  );
};

export default LicensedInsured;
